// extracted by mini-css-extract-plugin
export default {"modal":"ForgotPasswordForm_modal__P+Oh5","heading":"ForgotPasswordForm_heading__xFGvy","input":"ForgotPasswordForm_input__WNW92","btn":"ForgotPasswordForm_btn__vYOBM"};